/* failedTitleBox.tsx generated by @compiled/babel-plugin v0.38.1 */
import "./failedTitleBox.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import EditorWarningIcon from '@atlaskit/icon/core/migration/status-warning--editor-warning';
import { messages } from '@atlaskit/media-ui';
import { R300 } from '@atlaskit/theme/colors';
import { ErrorMessageWrapper, TitleBoxWrapper } from './titleBoxComponents';
var errorMessageWrapperStyles = null;
export var FailedTitleBox = function FailedTitleBox(_ref) {
  var breakpoint = _ref.breakpoint,
    _ref$customMessage = _ref.customMessage,
    customMessage = _ref$customMessage === void 0 ? messages.failed_to_load : _ref$customMessage;
  return /*#__PURE__*/React.createElement(TitleBoxWrapper, {
    breakpoint: breakpoint
  }, /*#__PURE__*/React.createElement(ErrorMessageWrapper, null, /*#__PURE__*/React.createElement(EditorWarningIcon, {
    label: 'Warning',
    LEGACY_size: 'small',
    LEGACY_margin: "0 ".concat("var(--ds-space-negative-025, -2px)"),
    color: "var(--ds-text-danger, ".concat(R300, ")"),
    size: "small"
  }), /*#__PURE__*/React.createElement("span", {
    className: ax(["_s7n4nkob _18u01b66 _2hwx1b66"])
  }, /*#__PURE__*/React.createElement(FormattedMessage, customMessage))));
};